export default "__VITE_ASSET__CpjsnGII__"